import React from 'react';
import { Tabs } from 'antd';
import CostExceptionTab from './CostExceptionTab';
import DisputeOverviewTab from './DisputeOverviewTab';
import CostExceptionWithErrorTab from './CostExceptionWithErrorTab';
function CostDetailsManagementPage() {

    const tabItems = [
        {
            label: '成本核算异常',
            key: '1',
            children: <CostExceptionWithErrorTab />,
        },
        {
            label: '成本异常',
            key: '2',
            children: <CostExceptionTab />,
        },
        {
            label: 'Dispute汇总',
            key: '3',
            children: <DisputeOverviewTab />,
        }
    ]

    return (
        <Tabs
            defaultActiveKey="1"
            type="line"
            size="medium"
            items={tabItems}
        />
    )
}

export default CostDetailsManagementPage;



    